import { Directive, OnInit, ElementRef, HostListener, forwardRef, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import * as BulmaCalendarVanTot from './bulma-calendar-van-tot.js';

@Directive({
  selector: '[appDatepickerVanTot]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatepickerVanTotDirective),
    multi: true
  }]
})
export class DatepickerVanTotDirective implements OnInit, OnDestroy, ControlValueAccessor {
  private calendar: any;
  private readonly dateFormat = 'dd-mm-yyyy';
  private onChangeCallback: (value: string) => void;
  private onTouchedCallback: () => void;

  @Input() van: Date;
  @Input() tot: Date;
  @Input() mindateVan: Date;
  @Input() maxdateVan: Date;
  @Input() mindateTot: Date;
  @Input() maxdateTot: Date;
  @Input() meetId: string;
  @Output() onReset: EventEmitter<any> = new EventEmitter();

  constructor(private elementRef: ElementRef) { }

  get nativeElement(): HTMLInputElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.calendar = new BulmaCalendarVanTot(this.nativeElement, {
      dateFormat: this.dateFormat,
      dateFrom: this.van,
      dateTo: this.tot,
      minDateVan: this.mindateVan,
      maxDateVan: this.maxdateVan,
      minDateTot: this.mindateTot,
      maxDateTot: this.maxdateTot,
      meetId: this.meetId,
      onSelect: selectedDates => this.onDateSelected(selectedDates),
      onReset: () => this.onDateResetted()
    });

    this.calendar.show();

    document.body.removeChild(this.calendar.datePickerContainer);
    this.nativeElement.parentElement.insertBefore(this.calendar.datePickerContainer,
      this.nativeElement.parentElement.firstElementChild);
  }

  ngOnDestroy() {
    this.calendar.destroy();
  }

  @HostListener('blur')
  onBlur() {
    this.onTouchedCallback();
  }

  onDateSelected(dates: string) {
    this.onChangeCallback(dates);
    this.writeValue(dates);
    this.calendar.show();
  }

  onDateResetted() {
    this.onReset.emit(null);
  }

  writeValue(val: string): void {
    this.nativeElement.value = val;

    if (val) {
      var dates = val.split('#');

      if (dates?.length > 1 && dates[1]) {
        this.nativeElement.value = this.reverseDate(dates[1]);
      } else if (dates?.length > 0) {
        this.nativeElement.value = this.reverseDate(dates[0]);
      }
    }
  }

  reverseDate(val: string): string {
    let date = val.split('-');
    if (!date || date.length < 2) {
      return null;
    }
    return date[2] + '-' + (Number(date[1]) + 1) + '-' + date[0];
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.nativeElement.disabled = isDisabled;
  }
}
